import React, { useState, useEffect } from 'react';
//Dependencias para uso de calendario
import { useCalendarApp, ScheduleXCalendar } from '@schedule-x/react';
import {createViewDay,createViewWeek,createViewMonthGrid,createViewMonthAgenda,} from '@schedule-x/calendar';
import '@schedule-x/theme-default/dist/index.css';
import EditEventModal from './Maintenance-components/EditEventModal';
import './Maintenance-styles/Maintenance.css';
import Loader from './Maintenance-components/Loader';
import Notification from './Maintenance-components/Notification';
import CreateEventModal from './Maintenance-components/CreateEventModal';
import { useFetch } from '../../../hooks/useFetch';

const Maintenance = ({events,handleChangEdit,server,hosts,groups,users,languaje,mode}) => {
  // console.log(hosts,groups,users)
    const [selectedEvent, setSelectedEvent] = useState(null);  //guardar evento seleccionado desde calendario siempre para edicion
    const [isEditModalOpen, setIsEditModalOpen] =  useState(false); //guardar estado de visibilidad de modal de edicion
    // const [hosts, setHosts] = useState([]); //catalogo host
    // const [groups, setGroups] = useState([]); //catalogo grupos
    // const [users, setUsers] = useState([]); //catalogo usuario
    const [isLoading, setIsLoading] = useState(false) //estado de visibilidad de loader
    const [notification, setNotification] = useState(null);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const [maintenanceType, setMaintenanceType] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
  //   const dataAgencies=useFetch('cassia/hosts','','','GET',server)
  // console.log(dataAgencies)

    // useEffect(() => {
    //     setIsLoading(true); // Muestra el loader al inicio de la carga  
    //     //promesa para asegurar lo que sucede hasta que los 3 catalogos se obtienen
    //     Promise.all([
    //         fetch('http://localhost:8000/get_groups').then((res) => res.json()),
    //         fetch(server.url+'/api/v1/cassia/hosts/').then((res) => res.json()),
    //         fetch('http://localhost:8000/users').then((res) => res.json()),
    //     ])
    //         .then(([groupsData, hostsData, usersData]) => {
    //             setGroups(groupsData);
    //             setHosts(hostsData);
    //             setUsers(usersData);
    //         })
    //         .catch((error) => {
    //             console.log('error al obtener catalogos groups, hosts, users: ', error)
    //         })
    //         .finally(()=> {
    //             setIsLoading(false)
    //         })
    // },[]);

    const openCreateModal = () => setIsCreateModalOpen(true);
    const closeCreateModal = () => setIsCreateModalOpen(false);
  
    const openEditModal = (event) => {
        setSelectedEvent(event);
        setIsEditModalOpen(true);
        // console.log("evento seleccionado para editar: ", event)
    }

    const closeEditModal = () => setIsEditModalOpen(false)


    const handleUpdateEvent = async (updatedEvent) => {
        try {
          setIsLoading(true); // Muestra el loader al inicio de la carga  
          const response = await fetch(
            `http://localhost:8000/maintenance/update_event/${updatedEvent.id}`,
            {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(updatedEvent),
            }
          );
    
          if (response.ok) {
            setNotification('Evento actualizado exitosamente');
            setIsEditModalOpen(false);
            window.location.reload();
          } else {
            setNotification('Error al actualizar el evento');
          }
        } catch (error) {
          setNotification('Error al actualizar el evento');
        } finally {
          setIsLoading(false); // Muestra el loader al inicio de la carga  
          setTimeout(() => setNotification(null), 7000);
        }
      };


      const handleCreateEvent = async (newEvent) => {
        setIsLoading(true);
        try {
          const response = await fetch('http://localhost:8000/maintenance/create_event', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newEvent),
          });
    
          if (response.ok) {
            setNotification('Evento creado exitosamente');
            closeCreateModal();
            setTimeout(() => window.location.reload(), 500); // Recarga la página
          } else {
            setNotification('Error al crear el evento');
          }
        } catch (error) {
          // console.error('Error al crear el evento:', error);
          setNotification('Error al crear el evento');
        } finally {
          setIsLoading(false);
          setTimeout(() => setNotification(null), 3000);
        }
      };



    const calendar =  useCalendarApp({
        views: [  createViewMonthGrid(),createViewDay(), createViewWeek(), createViewMonthAgenda()],
        defaultView: 'monthGrid',
        events,
        callbacks: {
            onEventClick: (event) => handleChangEdit(event)
        }
    });

    return (
      <div className='calendar-container'>
        {/* <div className='calendar-header'>
          <button onClick={openCreateModal}>Nuevo Evento</button>
        </div> */}
        <div className='calendar'>
        <ScheduleXCalendar calendarApp= {calendar}   defaultView="monthGrid"/>
        </div>
        {/* aqui va loader */}
        {isLoading && <Loader />}
        {/* aqui va notificacion */}
        {notification && <Notification message={notification} onClose={() => setNotification(null)} />}
        {isCreateModalOpen && (
          <CreateEventModal
            onClose={closeCreateModal}
            onCreate={handleCreateEvent}
            maintenanceType={maintenanceType}
            setMaintenanceType={setMaintenanceType}
            groups={groups}
            hosts={hosts}
            users={users}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
        )}
        {/* aqui va modal de edicion             */}
        {isEditModalOpen && selectedEvent &&(
            // llamar al modal de edicion y pasar argumento event y catalogo
            (<EditEventModal 
                event = {selectedEvent}
                onClose= {closeEditModal}
                onUpdate={handleUpdateEvent}
                groups= {groups}
                hosts = {hosts}
                users = {users}
                languaje={languaje} mode={mode} 
            />)
        )}
      </div>
    );
};

export default Maintenance;